
export const THUMBNAIL_WIDTH = Math.min(300, window.innerWidth - 40)
export const THUMBNAIL_HEIGHT = THUMBNAIL_WIDTH
export const RENDER_SCALE = /ios|mobile|android/i.test(window.navigator.userAgent) ? 2 : 1
export const TEXT_ELEMENT_LINE_LENGTH = 23;
export const DEMO_TEXT_ELEMENTS_LINES = [
  [TEXT_ELEMENT_LINE_LENGTH, TEXT_ELEMENT_LINE_LENGTH],
  [TEXT_ELEMENT_LINE_LENGTH, TEXT_ELEMENT_LINE_LENGTH],
  [TEXT_ELEMENT_LINE_LENGTH, TEXT_ELEMENT_LINE_LENGTH],
  [TEXT_ELEMENT_LINE_LENGTH, TEXT_ELEMENT_LINE_LENGTH, TEXT_ELEMENT_LINE_LENGTH],
];



// WEBPACK FOOTER //
// ./src/constants.js